import { SagaIterator } from 'redux-saga';
import {
  FetchLogsPayload,
  FetchLogPayload,
  ResponseListData,
  SaveStatusPayload,
  PendingException,
  ExportAllHosLogsPayload,
  SaveFormsPayload,
  FetchHosExportLinkPayload,
} from 'src/common/types';
import apiClient from 'src/common/apiClient';
import { ApproveRejectPendingEditsType } from 'src/features/hosLogs/hosLog/types';

export function fetchHosLogsApi(payload: FetchLogsPayload): SagaIterator<ResponseListData> {
  return apiClient.get('/eld/logs', payload);
}

export function fetchHosLogApi(payload: FetchLogPayload): SagaIterator {
  return apiClient.get(`/eld/logs/${payload.logId}`, payload);
}

export function editLogStatus(payload: SaveStatusPayload): SagaIterator {
  const {
    employeeId,
    logDate,
    statusPayload,
    modifiedOriginLogPayload,
    previousEventPayload,
    nextPeriodPayload,
  } = payload;

  const editEvents = [
    previousEventPayload?.statusPayload,
    modifiedOriginLogPayload?.statusPayload,
    statusPayload,
    nextPeriodPayload?.statusPayload,
  ].filter(item => !!item);

  return apiClient.patch(`/eld/logs/${employeeId}:${logDate}/duty_status`, {
    editEvents,
  });
}

export function saveException(payload: PendingException): SagaIterator {
  const { employeeId, logDate, ...rest } = payload;

  return apiClient.post(`/eld/logs/${employeeId}:${logDate}/exception`, rest);
}

export function removeException(payload: PendingException): SagaIterator {
  const { employeeId, logDate, ...rest } = payload;

  return apiClient.delete(`/eld/logs/${employeeId}:${logDate}/exception`, rest);
}

export function insertDutyStatus(payload: SaveStatusPayload): SagaIterator {
  const { employeeId, logDate, statusPayload, previousEventPayload, nextPeriodPayload } = payload;
  const editEvents = [
    previousEventPayload?.statusPayload,
    statusPayload,
    nextPeriodPayload?.statusPayload,
  ].filter(item => !!item);

  return apiClient.patch(`/eld/logs/${employeeId}:${logDate}/duty_status`, {
    editEvents,
  });
}

export function fetchUserLocations(logId: string): SagaIterator {
  return apiClient.get(`/eld/logs/locations/${logId}`);
}

export function fetchPendingEditsApi(payload: FetchLogPayload): SagaIterator {
  return apiClient.get(`eld/logs/${payload.logId}/admin_edits`, {});
}

export function patchPendingEditsApi(payload: ApproveRejectPendingEditsType): SagaIterator {
  const { logId, approveRejectData } = payload;
  return apiClient.patch(`eld/logs/${logId}/admin_edits`, approveRejectData);
}

export function exportAllHosLogsApi(payload: ExportAllHosLogsPayload): SagaIterator {
  return apiClient.post(`/eld/logs/complianceLogReport`, payload);
}

export function fetchHosExportLinkApi(payload: FetchHosExportLinkPayload): SagaIterator {
  return apiClient.get(`/eld/logs/complianceLogReport/${payload.jobId}`);
}

export function saveFormsApi(payload: SaveFormsPayload): SagaIterator {
  const { logDate, formPayload, employeeId } = payload;

  return apiClient.patch(`eld/logs/${employeeId}:${logDate}/metadata`, formPayload);
}

export function fetchDailyHeaderApi(payload: FetchLogPayload): SagaIterator {
  return apiClient.get(`eld/logs/${payload.logId}/dailyHeader`, {});
}
